export default function useRegionColors() {
  const RegionColors = {
    NEISA: '#d12e44',
    NWICSA: '#ed841a',
    MCSA: '#edbc1a',
    SEISA: '#82b84b',
    SAISA: '#32b8ad',
    PCCSC: '#4A90E2',
    MAISA: '#244a7d',
    GUEST: '#ff7996',
  }
  // const RegionColors = {
  //   PCCSC: '#ed841a',
  //   NEISA: '#244a7d',
  //   NWICSA: '#4A90E2',
  //   SEISA: '#82b84b',
  //   MCSA: '#d12e44',
  //   SAISA: '#edbc1a',
  //   MAISA: '#32b8ad',
  //   GUEST: '#ff7996',
  // }
  return RegionColors
}
